/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seconds: NonNullable<unknown> }} Offline_Set_SecondsInputs */

const en_us2_offline_set_seconds = /** @type {(inputs: Offline_Set_SecondsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s`)
};

const pt_br2_offline_set_seconds = /** @type {(inputs: Offline_Set_SecondsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s`)
};

const es_419_offline_set_seconds = /** @type {(inputs: Offline_Set_SecondsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s`)
};

const pt_pt2_offline_set_seconds = /** @type {(inputs: Offline_Set_SecondsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s`)
};

const fr_fr2_offline_set_seconds = /** @type {(inputs: Offline_Set_SecondsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s`)
};

const de_de2_offline_set_seconds = /** @type {(inputs: Offline_Set_SecondsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s`)
};

const it_it2_offline_set_seconds = /** @type {(inputs: Offline_Set_SecondsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s`)
};

/**
* | output |
* | --- |
* | "{seconds} s" |
*
* @param {Offline_Set_SecondsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_set_seconds = /** @type {((inputs: Offline_Set_SecondsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Set_SecondsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_set_seconds(inputs)
	if (locale === "es-419") return es_419_offline_set_seconds(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_set_seconds(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_set_seconds(inputs)
	if (locale === "de-DE") return de_de2_offline_set_seconds(inputs)
	if (locale === "it-IT") return it_it2_offline_set_seconds(inputs)
	return en_us2_offline_set_seconds(inputs)
});
export { offline_set_seconds as "offline.set_seconds" }